import type {GetBuildTypeBuildTagsApiArg} from '../services/rest'
import {stringifyId} from '../types'
import type {BuildTypeId} from '../types'

export const getBuildTypeTagsArg = (buildTypeId: BuildTypeId): GetBuildTypeBuildTagsApiArg => ({
  btLocator: `id:${stringifyId(buildTypeId)}`,
})
